export default {
  state: {
    list: [],
  },
  mutations: {
    setOrgansystems(state, payload) {
      state.list = payload
    },
  },
  actions: {
    queryOrgansystems({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'organsystems')
        .then(res => {
          commit('setOrgansystems', res.data)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getOrgansystems: state => {
      return state.list
    },
    getOrgansystemsOptions: state => {
      let organsystems = []
      if (state.list)
        for (let role of state.list)
          organsystems.push({id: role.id, name: role.name})
      organsystems.unshift({id: 0, name: 'All'})
      return organsystems
    },
    getOrgansystemName(state) {
      return function (id) {
        for (let item of state.list)
          if (item.id == id)
            return item.name
        return ''
      }
    }
  }
}